import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormArray, AbstractControl} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import * as Highcharts from 'highcharts';
import html2canvas from 'html2canvas';

export interface InvestmentProfile {
  value: string;
  viewValue: string;
}

// export interface TheData {
//   name: string;
//   income: number;
//   age: number;
//   retirementAge: number;
//   allowablePreTaxAdditional: number;
//   allowablePostTaxAdditional: number;
//   futureSuperBalance: number;
//   additionalContributionsTotal: number;
// }

@Component({
  selector: 'app-client-questionnaire',
  templateUrl: './client-questionnaire.component.html',
  styleUrls: ['./client-questionnaire.component.css'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS,
    useValue: { displayDefaultIndicatorType: false }
  }]
})

export class ClientQuestionnaireComponent implements OnInit {

    // spouseDetails: TheData = {
    //   name: 'Gillian',
    //   income: 100000,
    //   age: 24,
    //   retirementAge: 67,
    //   allowablePreTaxAdditional: 0,
    //   allowablePostTaxAdditional: 0,
    //   futureSuperBalance: 0,
    //   additionalContributionsTotal: 0
    // };

  baseChartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'area',
      width: 1000
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: 'Amount'
      },
      labels: {
        format: '${value}',
      }
    },
    plotOptions: {
      area: {
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: '<small>At Age: {point.key}</small><table>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      valueDecimals: 0
    },
    series: []
  };

  stepOne: FormGroup;
  stepTwo: FormGroup;
  stepThree: FormGroup;
  stepFour: FormGroup;
  stepFive: FormGroup;

  ordinaryInvestments: FormGroup;
  additionalInvestmentTotal = 0;
  additionalInvestmentMonthlyIncreaseTotal = 0;
  additionalPayments;
  additionalBalance;


  Highcharts: typeof Highcharts = Highcharts;
  investmentProfiles: InvestmentProfile[] = [
    {viewValue: 'Preservation - 3.10%', value: '3.10'},
    {viewValue: 'Defensive - 4.64%', value: '4.64'},
    {viewValue: 'Moderate - 5.45%', value: '5.45'},
    {viewValue: 'Balanced - 6.40%', value: '6.40'},
    {viewValue: 'Growth - 6.86%', value: '6.86'},
    {viewValue: 'High Growth - 7.41%', value: '7.41'},
    {viewValue: 'Enter Your Own', value: 'Enter your own'}
  ];
  todayDate: Date;
  retirementEndAge = 92;




  yourAllowablePreTaxAdditional = 0;
  yourAllowablePostTaxAdditional = 0;
  yourFutureSuperBalance = 0;
  yourAdditionalContributionsTotal = 0;
  yourChartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'area',
      width: 1000
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: 'Amount'
      },
      labels: {
        format: '${value}',
      }
    },
    plotOptions: {
      area: {
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: '<small>At Age: {point.key}</small><table>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      valueDecimals: 0
    },
    series: []
  };


  yourData;

  spouseAllowablePreTaxAdditional = 0;
  spouseAllowablePostTaxAdditional = 0;
  spouseFutureSuperBalance = 0;
  spouseAdditionalContributionsTotal = 0;
  spouseChartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'area',
      width: 1000
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: 'Amount'
      },
      labels: {
        format: '${value}',
      }
    },
    plotOptions: {
      area: {
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: '<small>At Age: {point.key}</small><table>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      valueDecimals: 0
    },
    series: []
  };


  spouseData;

  combinedChartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'area',
      width: 1000
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    yAxis: {
      title: {
        text: 'Amount'
      },
      labels: {
        format: '${value}',
      }
    },
    plotOptions: {
      area: {
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: '<small>At Age: {point.key}</small><table>',
      pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      valueDecimals: 0
    },
    series: []
  };


  // Repeating Workforce Exit Periods
  createWorkforceExit(): FormGroup {
    return this.formBuilder.group({
      length: 0,
      age: 0, // TODO: Be nice to validate between current age and retirement age here.
      frequency: 'Months'
    });
  }

  addWorkforceExit(isSpouse = false): void {
    const step = isSpouse ? 'stepFive' : 'stepThree';
    const exits = this[step].get('workforceExits') as FormArray;
    exits.push(this.createWorkforceExit());
  }

  removeWorkforceExit(index, isSpouse): void {
    const step = isSpouse ? 'stepFive' : 'stepThree';
    const exits = this[step].get('workforceExits') as FormArray;
    exits.removeAt(index);
  }

  // Repeating Additional Lump Payments
  createLump(): FormGroup {
    return this.formBuilder.group({
      amount: 0,
      when: 0,
      frequency: 'Months'
    });
  }

  addLump(isSpouse = false): void {
    const step = isSpouse ? 'stepFive' : 'stepThree';
    const lumpSumPayments = this[step].get('lumpSumPayments') as FormArray;
    lumpSumPayments.push(this.createLump());
  }

  removeLump(index, isSpouse): void {
    const step = isSpouse ? 'stepFive' : 'stepThree';
    const lumpSumPayments = this[step].get('lumpSumPayments') as FormArray;
    lumpSumPayments.removeAt(index);
  }

  // Repeating Ordinary Investments
  createOrdinaryInvestment(): FormGroup {
    return this.formBuilder.group({
      amount: 0,
      payment: 0,
      frequency: 'Months'
    });
  }

  addOrdinaryInvestment(): void {
    const ordinaryInvestments = this.ordinaryInvestments.get('ordinaryInvestments') as FormArray;
    ordinaryInvestments.push(this.createOrdinaryInvestment());
  }

  removeOrdinaryInvestment(index): void {
    const ordinaryInvestments = this.ordinaryInvestments.get('ordinaryInvestments') as FormArray;
    ordinaryInvestments.removeAt(index);
  }

  // TODO: Tidy / Variable for Yearly Maximum Rate / Static?
  calculateMaxAdditionalContributionBeforeTax(income, employerSuperContributionRate, additionalPreTaxFreq): number {
    //const rateFor2109 = 25000;
    const rateFor2021 = 27500;
    const yourIncome = Number(income);
    const employerRate = Number(employerSuperContributionRate);
    const employerContribution = (yourIncome / 100) * employerRate;
    const maxAllowed = (rateFor2021 - employerContribution) / Number(additionalPreTaxFreq);
    return maxAllowed > 0 ? maxAllowed : 0;
  }

  // TODO: Tidy / Variables for Tax Rates / Static?
  calculateMaxAdditionalContributionAfterTax(balance, income, beforeTaxContribution, afterTaxFrequency, beforeTaxFrequency): number {

    beforeTaxContribution = beforeTaxContribution === undefined ? 0 : beforeTaxContribution;

    if ( balance >= 1600000 ) { return 0; } // No additional allowed after 1.6 million.

    let incomeAfterTax; // income tax rates taken from https://www.ato.gov.au/rates/individual-income-tax-rates/

    if ( income <= 18200 ) { incomeAfterTax = income; } // no tax to pay
    if ( income > 18200 && income <= 37000 ) { incomeAfterTax = income - ( ( income - 18200) * 0.19 ); }
    if ( income > 37000 && income <= 80000 ) { incomeAfterTax = income - ( 3572 + ( income - 37000) * 0.325 ); }
    if ( income > 80000 && income <= 180000 ) { incomeAfterTax = income - ( 17547 + ( income - 80000) * 0.37 ); }
    if ( income > 180000 ) { incomeAfterTax = income - ( 54547 + ( income - 180000) * 0.45 ); }

    incomeAfterTax = incomeAfterTax - (incomeAfterTax * 0.02) - (beforeTaxContribution * beforeTaxFrequency);
    incomeAfterTax = incomeAfterTax / afterTaxFrequency;

    return incomeAfterTax;
  }

  getYearsOfRetirement(retirementStartAge): number {
    return this.retirementEndAge - retirementStartAge;
  }

  sumTwoNumbers(firstNumber, secondNumber): number {
    return Number(firstNumber) + Number(secondNumber);
  }

  setAllowableAdditionalContributions(spouse = false) {

    const stepDetails = spouse ? 'stepFour' : 'stepTwo';
    const stepSuper = spouse ? 'stepFive' : 'stepThree';
    const prefix = spouse ? 'spouse' : 'your';

    this[prefix + 'AllowablePreTaxAdditional'] = this.calculateMaxAdditionalContributionBeforeTax(
      this[stepDetails].value.income,
      this[stepSuper].value.employeeSuperContrib,
      this[stepSuper].value.additionalPreTaxFrequency
      );

    this[prefix + 'AllowablePostTaxAdditional'] = this.calculateMaxAdditionalContributionAfterTax(
      this[stepSuper].value.super,
      this[stepDetails].value.income,
      this[stepSuper].value.preTaxAdditionalAmount,
      this[stepSuper].value.additionalPostTaxFrequency,
      this[stepSuper].value.additionalPreTaxFrequency
    );

    if (this[stepSuper].value.makeAdditionalContributions === 'false') {

      this[stepSuper].controls.preTaxAdditionalAmount.disable();
      this[stepSuper].controls.postTaxAdditionalAmount.disable();

    } else {

      if (this[prefix + 'AllowablePreTaxAdditional'] === 0) {
        this[stepSuper].controls.preTaxAdditionalAmount.disable();
      } else {
        this[stepSuper].controls.preTaxAdditionalAmount.enable();
        this[stepSuper].controls.preTaxAdditionalAmount.updateValueAndValidity();
      }

      if (this[prefix + 'AllowablePostTaxAdditional'] === 0 ) {
        this[stepSuper].controls.postTaxAdditionalAmount.disable();
      } else {
        this[stepSuper].controls.postTaxAdditionalAmount.enable();
        this[stepSuper].controls.postTaxAdditionalAmount.updateValueAndValidity();
      }
    }
  }

  calculateResults() {
    // TODO: This should build two instances of the "The Data" objects providing simple access to each persons data.

    // Calculate results or the primary user
    this.buildEstimate(false);

    // Calculate results for spouse if selected
    if (this.stepOne.get('includeSpouse').value === 'true') {
      this.buildEstimate(true);
    }
  }

  buildEstimate(isSpouse = false) {
    const stepDetails = isSpouse ? 'stepFour' : 'stepTwo';
    const stepSuper = isSpouse ? 'stepFive' : 'stepThree';

    const term = this[stepDetails].value.retirementAge - this[stepDetails].value.age; // Calculate Years From Now until Retirement
    const monthlyEmpContrib = (this[stepSuper].value.employeeSuperContrib / 100) * (this[stepDetails].value.income / 12); // Determine you monthly contribution - TEMP: Guess an issue is here as this amount would increase over time.
    const monthlyEmpContribTaxed = monthlyEmpContrib * 0.85; // 15% Tax on employee contribution

    const investmentReturn = this[stepSuper].value.investmentSelector === 'Enter your own' ? Number(this[stepSuper].value.manualInvestmentEntry) : Number(this[stepSuper].value.investmentSelector);
    //const investmentSelector = Number(this[stepSuper].value.investmentSelector); // Get the return rate for the investment



    const superBalance: number = Number(this[stepSuper].value.super); // Get the current super balance
    this.processInputs(term, monthlyEmpContribTaxed, investmentReturn, superBalance, Number(this[stepDetails].value.age), isSpouse);
  }

  // TODO: Break this up
  processInputs(yearsUntilRetirement, monthlyEmployerContrib, investmentReturnPercentage, currentSuperAmount, currentAge, isSpouse = false) {
    const numOfDataPoints = yearsUntilRetirement * 12; // Number of months between current age and retirement
    const payments = new Array(numOfDataPoints).fill(monthlyEmployerContrib); // Populate an array with the current monthly emp contribution for every month between now and retirement

    const interval = 12;
    const YSI = 0.033; // 3.3% p.a
    const CPI = 0.024; // 2.4% p.a

    let lastValue = payments[0];

    // Increase employee contribution every 12 months - TODO: This is all disabled atm
    payments.map((value, index) => {

        if (index % interval === 0 && index !== 0) {

          const increaseAmount = lastValue * YSI - CPI;
          value = lastValue + increaseAmount;
          value = Math.round(value);
          value = Math.floor(value);
          // Inflation at payment time?
          //const year = index / 12;
          //const valueAtTime = value * Math.pow(1 / ( 1 + CPI / 12), year);

          //console.log(
          //   `Index: ` + index
          //   //+ ` - Wage Increase: ` + increaseAmount
          //   + ` - Previous Payment: ` + lastValue
          //   + ` - New Payment: ` + value
          //   // + ` - Year: ` + year
          //   // + ' - Value at time ' + valueAtTime
          // );

          lastValue = value;

          updateArrayValuesByRange(index + 1, interval, payments, value);

        }
      }
    );


    // Additional Ordinary Investments
    this.additionalInvestmentTotal = 0;
    this.additionalInvestmentMonthlyIncreaseTotal = 0;

    // this.additionalPayments = [];
    // this.additionalBalance = [];


    if (this.stepOne.get('includeOrdinaryInvestments').value === 'true') {
      for (const item of this.ordinaryInvestments.get('ordinaryInvestments').value) {


        //this.additionalInvestmentMonthlyIncreaseTotal += item.frequency === 'Months' ? item.payment : item.payment / 12;

        let payment = item.frequency === 'Months' ? item.payment : item.payment / 12;
        let output = payment * numOfDataPoints;

        this.additionalInvestmentTotal += item.amount + output;

        console.log('Add total', this.additionalInvestmentTotal);

        // updateArrayValuesByRange(0, numOfDataPoints, this.additionalBalance, this.additionalInvestmentMonthlyIncreaseTotal / 12, true);
        // updateArrayValuesByRange(0, numOfDataPoints, this.additionalPayments, payment, true);

        //const length = item.frequency === 'Months' ? item.length : item.length * 12;
        //const when = ((item.age - this[stepDetails].get('age').value) * 12);
        //updateArrayValuesByRange(when, length + 1, payments, 0);
      }
    }


    // Workforce Exits
    const stepSuper = isSpouse ? 'stepFive' : 'stepThree';
    const stepDetails = isSpouse ? 'stepFour' : 'stepTwo';
    if (this[stepSuper].get('leavingWorkforce').value === 'true') {
      for (const item of this[stepSuper].get('workforceExits').value) {
        const length = item.frequency === 'Months' ? item.length : item.length * 12;
        const when = ((item.age - this[stepDetails].get('age').value) * 12);
        updateArrayValuesByRange(when, length + 1, payments, 0);
      }
    }

    // Reset Additional Contribution Totals
    if (isSpouse) {
      this.spouseAdditionalContributionsTotal = 0;
    } else {
      this.yourAdditionalContributionsTotal = 0;
    }

    // Additional Contributions
    if (this[stepSuper].get('makeAdditionalContributions').value === 'true') {

      let preTaxMonthly = 0;
      let postTaxMonthly = 0;

      // Pre Tax Additional Contribution

      if (this[stepSuper].get('preTaxAdditionalAmount').value.amount !== 0) {
        // Before Tax - Taxed at 15% prior to adding
        const preTax = this[stepSuper].get('preTaxAdditionalAmount').value * 0.85;
        const preTaxFreq = this[stepSuper].get('additionalPreTaxFrequency');

        switch (preTaxFreq.value) {
          case '1':
            preTaxMonthly = preTax / 12;
            break;

          case '12':
            preTaxMonthly = preTax;
            break;

          case '52':
            preTaxMonthly = preTax * 4.333;
            break;
        }
      }

      // Post Tax Additional Contribution

      if (this[stepSuper].get('postTaxAdditionalAmount').value.amount !== 0) {
        // After Tax
        const postTax = this[stepSuper].get('postTaxAdditionalAmount').value;
        const postTaxFreq = this[stepSuper].get('additionalPostTaxFrequency');

        switch (postTaxFreq.value) {
          case '1':
            postTaxMonthly = postTax / 12;
            break;

          case '12':
            postTaxMonthly = postTax;
            break;

          case '52':
            postTaxMonthly = postTax * 4.33;
            break;
        }
      }

      // Calculate the total additional contributions being made
      if (isSpouse) {
        this.spouseAdditionalContributionsTotal += preTaxMonthly * numOfDataPoints;
        this.spouseAdditionalContributionsTotal += postTaxMonthly * numOfDataPoints;
      } else {
        this.yourAdditionalContributionsTotal += preTaxMonthly * numOfDataPoints;
        this.yourAdditionalContributionsTotal += postTaxMonthly * numOfDataPoints;
      }

      updateArrayValuesByRange(0, numOfDataPoints, payments, preTaxMonthly, true);
      updateArrayValuesByRange(0, numOfDataPoints, payments, postTaxMonthly, true);

    }

    // Lump Sum Payments
    if (this[stepSuper].get('makeLumpSum').value === 'true') {
      for (const item of this[stepSuper].get('lumpSumPayments').value) {
        const when = item.frequency === 'Months' ? item.when : item.when * 12;
        updateArrayValuesByRange(when + 1, 1, payments, item.amount);
        if (isSpouse) {
          this.spouseAdditionalContributionsTotal += item.amount;
        } else {
          this.yourAdditionalContributionsTotal += item.amount;
        }
      }
    }

    const data = calculateEstimate(investmentReturnPercentage, numOfDataPoints, currentSuperAmount, payments);

    if (isSpouse) {
      this.spouseData = data;
    } else {
      this.yourData = data;
    }

    function updateArrayValuesByRange(startPosition, valuesToUpdate, arrayRef, newValue, addToExisting = false) {

      for (let i = 0; i < valuesToUpdate; i++) {

        // DODGY
        if (startPosition === 0 && arrayRef[startPosition + i - 1] === 0) {
          // Most likely going to be a pre/post tax contrib during a workforce exit - don't add pre/post additional payment in this period
        } else {
          arrayRef[startPosition + i - 1] = addToExisting ? newValue + arrayRef[startPosition + i - 1] : newValue;
        }
      }
    }

    function calculateEstimate(investmentReturnPercentage, dataPoints, initialBalance, payments) {

      const data = {
        payment: [],
        interest: [],
        balance: [],
        annualBalance: [],
        annualPayment: [],
        age: [],
        // TODO: Start the drawdown array from the end of the growth phase - cleaner?
        fundAmount: new Array(dataPoints / 12).fill(null),
        minDrawDown: new Array(dataPoints / 12).fill(null),
        minDrawDownPercentage: new Array(dataPoints / 12).fill(null)
      };

      let monthlyInterestRate = investmentReturnPercentage / 12 / 100;

      monthlyInterestRate = monthlyInterestRate - 0.004;

      let base: number = initialBalance;

      let monthCounter = 0;
      let yearlyPayment = 0;
      let year = 0;

      for (let i = 0; i < dataPoints; i++) {

        const monthlyPayment: number = payments[i] || 0;

        //base = (base + monthlyPayment);
        base = (base + monthlyPayment) * (1 + monthlyInterestRate);

        data.payment.push(Math.round(monthlyPayment));
        data.balance.push(Math.round(base));
        data.interest.push();

        if (monthCounter < 11) {
          yearlyPayment += Math.round(monthlyPayment);
          monthCounter++;
        } else {
          year++;

          //const monthlyCPI = 0.024;
          //const valueAtTime = base * Math.pow(1 / (1 + monthlyCPI), year);
          //console.log(year, base);
          //console.log(year, valueAtTime);

          monthCounter = 0;
          data.annualPayment.push(Math.round(monthlyPayment) + yearlyPayment);
          data.annualBalance.push(Math.round(base));
          yearlyPayment = 0;
          data.age.push(currentAge + Math.floor(i / 12) + 1);
        }
      }


      // DRAWDOWN PHASE
      let fundAmount = data.balance[data.balance.length - 1]; // TODO: Get peak fund amount cleaner than this
      const retirementAge = data.age[data.age.length - 1]; // TODO: Get retirement age cleaner than this

      const drawdownRules = [
        {startAge: 65, endAge: 74, minPercentage: 0.05},
        {startAge: 75, endAge: 79, minPercentage: 0.06},
        {startAge: 80, endAge: 84, minPercentage: 0.07},
        {startAge: 85, endAge: 89, minPercentage: 0.09},
        {startAge: 90, endAge: 94, minPercentage: 0.11},
        {startAge: 95, endAge: 205, minPercentage: 0.14}
      ];

      drawdownRules.forEach((drawdownPeriod) => {
        calculateMinimumDrawdown(drawdownPeriod.startAge, drawdownPeriod.endAge, drawdownPeriod.minPercentage, 92);
      });

      // Calculate the minimum drawdown amount and percentage for the given drawdown period until the age cutoff is reached
      function calculateMinimumDrawdown(startAge, endAge, minPercentage, ageCutoff) {

        const numberOfYearsAtRate = endAge - startAge;

        for (let i = numberOfYearsAtRate; i > 0; i--) {

          // Stop populating once there is no money left in the fund
          if (fundAmount < 1) {
            return;
          }

          // Only return from when the retirement age is reached or below age cap
          if ((endAge - i) <= retirementAge || (endAge - i) > ageCutoff) {
          } else {
            data.age.push(endAge - i);
            const periodAmount = minPercentage * fundAmount;
            data.minDrawDownPercentage.push(minPercentage * 100);
            data.minDrawDown.push(periodAmount);
            fundAmount -= periodAmount;
            data.fundAmount.push(fundAmount);
          }
        }
      }

      // RETURN CALCULATION OBJECT
      return data;
    }


    const prefix = isSpouse ? 'spouse' : 'your';

    this[prefix + 'FutureSuperBalance'] = data.balance[data.balance.length - 1];

    this[prefix + 'ChartOptions'].series = [
      {
        name: 'Your Estimated Super Balance',
        type: 'area',
        data: data.annualBalance,
        tooltip: {
          valuePrefix: '$',
        },
        color: '#2DAD85'
      },
      {
        name: 'Contributions (Employer, Lump Sum, Additional)',
        type: 'area',
        data: data.annualPayment,
        tooltip: {
          valuePrefix: '$',
        },
        color: '#2585A8'
      },

      {
        name: 'Remaining Super Amount',
        type: 'area',
        data: data.fundAmount,
        tooltip: {
          valuePrefix: '$',
        },
        color: '#7360A4'
      },

      {
        name: 'Minimum Super Draw Down Amount',
        type: 'area',
        data: data.minDrawDown,
        tooltip: {
          valuePrefix: '$',
        },
        color: '#EC7449'
      },

      {
        name: 'Minimum Super Draw Down Percentage',
        type: 'area',
        data: data.minDrawDownPercentage,
        tooltip: {
          valueSuffix: '%',
        },

      }

    ];

    this[prefix + 'ChartOptions'].xAxis = {
      categories: data.age,
      title: {
        text: 'Age'
      },
      tickmarkPlacement: 'on',
    };

    if (!isSpouse) {
      const elem = document.getElementById('yourGraph');
      if (elem) {
        Highcharts.chart('yourGraph', this[prefix + 'ChartOptions']);
      }
    } else {
      const elem = document.getElementById('spouseGraph');
      if (elem) {
        Highcharts.chart('spouseGraph', this[prefix + 'ChartOptions']);
      }


      // COMBINED DODGINESS
      const combinedData = {
        annualBalance: [],
        annualPayment: [],
        age: [],
        fundAmount: [],
        minDrawDown: [],
        minDrawDownPercentage: []
      };

      //Start from first to retire
      let retirementAge2 = 0;
      let firstToRetire = '';
      if (this.stepTwo.value.retirementAge <= this.stepFour.value.retirementAge) {
        retirementAge2 = this.stepTwo.value.retirementAge;
        combinedData.age = this.yourData.age.slice(0, (retirementAge2 - this.yourData.age[0]) + 1);
        firstToRetire = this.stepTwo.value.name;
      } else {
        retirementAge2 = this.stepFour.value.retirementAge;
        combinedData.age = this.spouseData.age.slice(0, (retirementAge2 - this.spouseData.age[0] + 1));
        firstToRetire = this.stepFour.value.name;
      }

      // Populate for Drawdown
      combinedData.fundAmount = new Array( combinedData.age.length).fill(null);
      combinedData.minDrawDown = new Array( combinedData.age.length).fill(null);
      combinedData.minDrawDownPercentage = new Array(combinedData.age.length).fill(null);

      combinedData.age.forEach((data2, index) => {
        const spouseAnnualPayment = this.spouseData.annualPayment[this.spouseData.age.indexOf(data2)] || 0;
        const yourAnnualPayment = this.yourData.annualPayment[this.yourData.age.indexOf(data2)] || 0;

        if (spouseAnnualPayment + yourAnnualPayment !== 0 ) {
          combinedData.annualPayment.push(spouseAnnualPayment + yourAnnualPayment);
        }

        const spouseAnnualBalance = this.spouseData.annualBalance[this.spouseData.age.indexOf(data2)] || 0;
        const yourAnnualBalance = this.yourData.annualBalance[this.yourData.age.indexOf(data2)] || 0;

        if (spouseAnnualBalance + yourAnnualBalance !== 0 ) {
          combinedData.annualBalance.push(spouseAnnualBalance + yourAnnualBalance);
        }

      });

      // DRAWDOWN PHASE
      let fundAmount = combinedData.annualBalance[combinedData.annualBalance.length - 1]; // TODO: Get peak fund amount cleaner than this

      const drawdownRules = [
        {startAge: 65, endAge: 74, minPercentage: 0.05},
        {startAge: 75, endAge: 79, minPercentage: 0.06},
        {startAge: 80, endAge: 84, minPercentage: 0.07},
        {startAge: 85, endAge: 89, minPercentage: 0.09},
        {startAge: 90, endAge: 94, minPercentage: 0.11},
        {startAge: 95, endAge: 205, minPercentage: 0.14}
      ];

      drawdownRules.forEach((drawdownPeriod) => {
        const numberOfYearsAtRate = drawdownPeriod.endAge - drawdownPeriod.startAge;

        for (let i = numberOfYearsAtRate; i > 0; i--) {

          // Stop populating once there is no money left in the fund
          if (fundAmount < 1) {
            return;
          }

          // Only return from when the retirement age is reached or below age cap
          if ((drawdownPeriod.endAge - i) <= retirementAge2 || (drawdownPeriod.endAge - i) > 92) {
          } else {

            combinedData.age.push(drawdownPeriod.endAge - i);
            const periodAmount = drawdownPeriod.minPercentage * fundAmount;
            combinedData.minDrawDownPercentage.push(drawdownPeriod.minPercentage * 100);
            combinedData.minDrawDown.push(periodAmount);
            fundAmount -= periodAmount;

            combinedData.fundAmount.push(fundAmount);
          }
        }
      });

      this.combinedChartOptions.series = [
        {
          name: 'Your Estimated Super Balance',
          type: 'area',
          data:  combinedData.annualBalance,
          color: '#2DAD85',
          tooltip: {
            valuePrefix: '$',
          },
        },
        {
          name: 'Contributions (Employer, Lump Sum, Additional)',
          type: 'area',
          data:  combinedData.annualPayment,
          color: '#2585A8',
          tooltip: {
            valuePrefix: '$',
          },
        },
        {
          name: 'Remaining Super Amount',
          type: 'area',
          data: combinedData.fundAmount,
          tooltip: {
            valuePrefix: '$',
          },
          color: '#7360A4'
        },

        {
          name: 'Minimum Super Draw Down Amount',
          type: 'area',
          data: combinedData.minDrawDown,
          tooltip: {
            valuePrefix: '$',
          },
          color: '#EC7449'
        },

        {
          name: 'Minimum Super Draw Down Percentage',
          type: 'area',
          data: combinedData.minDrawDownPercentage,
          tooltip: {
            valueSuffix: '%',
          },

        }];

      this.combinedChartOptions.xAxis = {
        categories: combinedData.age,
        title: {
          text: 'First to Retire (' + firstToRetire + ') Age'
        },
        tickmarkPlacement: 'on',
      };

      const elem2 = document.getElementById('combinedGraph');
      if (elem2) {
        Highcharts.chart('combinedGraph', this.combinedChartOptions);
      }
    }

  }

  // TODO: Allow input of Array of elements to hide)
  exportHTMLElementAsImageByID(event, element, transparentBackground = false, ) {

    // Navigate two levels up the DOM tree to obtain the correct container element.
    // const parentElement = event.target.parentElement.parentElement;

    const elementToCapture = document.getElementById(element);

    // Get original display value of the elements parent
    const originalDisplayValue = elementToCapture.parentElement.style.display;

    // Set parent display value to inline block to remove as much whitespace as possible.
    elementToCapture.parentElement.style.display = 'inline-block';

    // Hide the calling button
    event.target.style.display = 'none';

    // Get the current scroll position
    const x = window.pageXOffset || document.documentElement.scrollLeft;
    const y = window.pageYOffset || document.documentElement.scrollTop;

    // Set scroll to top of screen to fix render bug with html2canvas
    window.scrollTo(0, 0);

    const options = transparentBackground ? { backgroundColor: 'null' } : {};

    // Provide html2canvas with the element to convert into an image
    html2canvas(elementToCapture, options).then(canvas => {

      // Restore the calling button
      event.target.style.display = 'inline-block';

      // Restore the scroll position to the original location
      window.scrollTo(x, y);

      // Restore the original display value of the elements parent
      elementToCapture.parentElement.style.display = originalDisplayValue;

      // Convert the image to a Base64 string
      const contentType = 'image/png';
      const base64ImageData = canvas.toDataURL(contentType);

      // Launch a new browser tab and populate it with the base64 image.
      const newWindow = window.open('', '_blank');
      newWindow.document.write(`
        <head>
            <style>

              img {
                -webkit-user-select: none;
                color:white;
              }

              body {
                  margin: 0;
                  background: #0e0e0e;
                  text-align: center;
                  position: absolute;
                  top: 50%;
                  left:50%;
                  -webkit-transform: translate(-50%, -50%);
                  transform: translate(-50%, -50%;
              }
            </style>
            <title>Press CTRL + C</title>
        </head>
        <body>
            <img alt=" - Unable to render image" src="${ base64ImageData }" />
        </body>
        <script>
            document.oncopy = logCopy;
            function logCopy(event) {
                event.preventDefault();
                window.close();
            }
        </script>
        `);
    });
  }

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {

    const testMode = false;

    this.todayDate = new Date();

    this.ordinaryInvestments = this.formBuilder.group({
      ordinaryInvestments: this.formBuilder.array([ this.createOrdinaryInvestment() ]),
    });

    this.stepOne = this.formBuilder.group({
      includeSpouse: 'false',
      includeOrdinaryInvestments: 'false'
    });

    this.stepTwo = this.formBuilder.group({
      name: [testMode ? 'Rian' : '', [Validators.required]],
      income:   [testMode ? '115000' : '', [Validators.required, Validators.min(10000), Validators.max(10000000)]] ,
      age:  [testMode ? '34' : '', [Validators.required, Validators.min(16), Validators.max(75)]] ,
      retirementAge: [67, [Validators.required, Validators.min(60), Validators.max(75)]],
    });

    this.stepThree = this.formBuilder.group({
      super : [testMode ? '110000' : '' , [Validators.required, Validators.min(10000), Validators.max(10000000)]] ,
      investmentSelector: '6.40',
      manualInvestmentEntry: '6.00',
      employeeSuperContrib: 10,
      leavingWorkforce: false,
      workforceExits: this.formBuilder.array([ this.createWorkforceExit() ]),
      makeLumpSum: false,
      lumpSumPayments: this.formBuilder.array([ this.createLump() ]),
      makeAdditionalContributions: false,
      additionalPreTaxFrequency: '12',
      additionalPostTaxFrequency: '12',
      preTaxAdditionalAmount: [0, [
        Validators.min(0),
        (control: AbstractControl) => Validators.max(this.yourAllowablePreTaxAdditional)(control)
      ]],
      postTaxAdditionalAmount: [0, [
        Validators.min(0),
        (control: AbstractControl) => Validators.max(this.yourAllowablePostTaxAdditional)(control)
      ]]
    });

    this.stepFour = this.formBuilder.group({
      name: [testMode ? 'Gillian' : '', [Validators.required]],
      income: [testMode ? '75000' : '', [Validators.required, Validators.min(10000), Validators.max(10000000)]] ,
      age: [testMode ? '33' : '', [Validators.required, Validators.min(16), Validators.max(75)]],
      retirementAge: [67, [Validators.required, Validators.min(60), Validators.max(75)]],
    });

    this.stepFive = this.formBuilder.group({
      super : [testMode ? '100000' : '' , [Validators.required, Validators.min(10000), Validators.max(10000000)]] ,
      investmentSelector: '6.40',
      employeeSuperContrib: 10,
      leavingWorkforce: false,
      workforceExits: this.formBuilder.array([ this.createWorkforceExit() ]),
      makeLumpSum: false,
      lumpSumPayments: this.formBuilder.array([ this.createLump() ]),
      makeAdditionalContributions: false,
      additionalPreTaxFrequency: '12',
      additionalPostTaxFrequency: '12',
      preTaxAdditionalAmount: [0, [
        Validators.min(0),
        (control: AbstractControl) => Validators.max(this.spouseAllowablePreTaxAdditional)(control)
      ]],
      postTaxAdditionalAmount: [0, [
        Validators.min(0),
        (control: AbstractControl) => Validators.max(this.spouseAllowablePostTaxAdditional)(control)
      ]]
    });

  }

}


